import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Checkbox.module.scss.js';

var Checkbox = function (_a) {
    var _b;
    var label = _a.label, inputProps = _a.inputProps, className = _a.className, style = _a.style, hasError = _a.hasError;
    return (jsx("div", __assign({ className: clsx(styles.checkbox, className), style: style }, { children: jsxs("label", __assign({ htmlFor: inputProps.name, className: clsx(styles['checkbox__html-label']) }, { children: [jsx("input", __assign({ type: "checkbox", id: inputProps.name }, inputProps, { value: inputProps.value })), jsxs("div", __assign({ className: styles.checkbox__label }, { children: [jsx("span", { className: clsx(styles.checkbox__checkmark, (_b = {}, _b[styles['checkbox__checkmark--error']] = hasError, _b)) }), jsx("span", __assign({ className: styles['form-element__label'] }, { children: label }))] }))] })) })));
};

export { Checkbox };
